import React from "react";
import { Button } from "@shared/ui/button";
import { GenericTable } from "@shared/components/GenericTable";
import { TableColumn } from "@shared/types/table";
import { useParams } from "react-router-dom";
import { useGetPlanDetailByTab } from "../../../hooks";

export const LinkedConsumers = () => {
  const { id } = useParams();
  const { data: consumers } = useGetPlanDetailByTab(id, "consumers");

  const columns: TableColumn<any>[] = [
    {
      key: "accountNo",
      header: "Account",
      render: (val, row) => {
        const account = val || row.accountNo || "-";
        return <span>{account}</span>;
      },
    },
    {
      key: "accountName",
      header: "Customer",
      render: (val, row) => val || row.accountName || "-",
    },
    {
      key: "utilityServices",
      header: "Utility Services",
      render: (val, row) =>
        (val || row.utilityService || []).flat().join(", ") || "-",
    },
    { key: "category", header: "Category", render: (val) => val || "-" },
    {
      key: "subCategory",
      header: "Sub Category",
      render: (val, row) => val || row.subCategory || "-",
    },
    {
      key: "servicePremise",
      header: "Service Premise",
      render: (val, row) => val || row.servicePremise || "-",
    },
    {
      key: "outstanding",
      header: "Outstanding",
      render: (val) => (val != null ? `$${Number(val).toFixed(2)}` : "-"),
    },
  ];

  const data = consumers?.result || [];

  return (
    <div className="space-y-4">
      <div className="border border-gray-200 rounded-lg overflow-hidden">
        <GenericTable data={data} columns={columns} rowKey="accountNo" />
      </div>
    </div>
  );
};
